// RUN IMMEDIATELY
svg4everybody();

// ON DOCUMENT READY
$(document).ready(function(){
    egoeHomeHeader.init();
    egoeScrollToAnchor.init();
});


// IMAGE SWITCH
const fo__triggers =  document.querySelectorAll(".plane__overlay__item__trigger");
const fo__baseLight = document.getElementById("fo__base_light");
const fo__baseDark =  document.getElementById("fo__base_dark");

Array.from(fo__triggers).forEach(link => {
    link.addEventListener('mouseenter', function() {
        var ph = document.getElementById(this.dataset.placeholder);
        if (!ph) return;
        ph.classList.add("--active");
        ph.classList.remove("--hidden");
    });
    link.addEventListener('mouseleave', function() {
        var ph = document.getElementById(this.dataset.placeholder);
        if (!ph) return;
        ph.classList.remove("--active");
        ph.classList.add("--hidden");
    });
});

// THEME SWITCHER
//const currentTheme = localStorage.getItem('theme');
const toggleSwitch = document.querySelector('.theme-switch input[type="checkbox"]');
/*
if (currentTheme) {    
    if (currentTheme === 'dark') {
        fo__baseLight.classList.add("--hidden");
        fo__baseDark.classList.remove("--hidden"); 
        toggleSwitch.checked = true;
    }
}
*/
function switchTheme(e) {
    if (e.target.checked) {
        fo__baseLight.classList.add("--hidden");
        fo__baseDark.classList.remove("--hidden");
        document.documentElement.setAttribute('data-theme', 'dark');
        //localStorage.setItem('theme', 'dark');
    }
    else {
        fo__baseLight.classList.remove("--hidden");
        fo__baseDark.classList.add("--hidden");
        document.documentElement.setAttribute('data-theme', 'light');
        //localStorage.setItem('theme', 'light');
    }
}
toggleSwitch.addEventListener('change', switchTheme, false);

var btnOpenStatus = true;
document.getElementById('plane__news__panel__btn__close').style.opacity = "0";
$("#plane__news__panel__btns").click(function () {
    if(btnOpenStatus == true){
        openFeed();
    }else{
        closeFeed();
    }
});


var mainContent = document.getElementById("content");
var headerPanel = document.getElementById("header");
var contentSidePanel = document.getElementById("content-news-panel");
var footerPanel = document.getElementsByClassName("footer")[0];

function openFeed(){
    mainContent.style.width = "calc(100% - 220px)";
    headerPanel.style.width = "calc(100% - 230px)";
    contentSidePanel.style.right = "0px";
    footerPanel.style.width = "calc(100% - 230px)";

    document.getElementById('plane__news__panel__btn__open').style.opacity = "0";
    document.getElementById('plane__news__panel__btn__close').style.opacity = "1";
    btnOpenStatus = false;

}
function closeFeed(){
    mainContent.style.width = "100%";
    headerPanel.style.width = "100%";
    contentSidePanel.style.right = "-220px";
    footerPanel.style.width = "100%";

    document.getElementById('plane__news__panel__btn__open').style.opacity = "1";
    document.getElementById('plane__news__panel__btn__close').style.opacity = "0";
    btnOpenStatus = true;

}


function checkWidthAndSetElement() {
    var windowWidth = $(window).width();
    if (windowWidth < 993 && btnOpenStatus == false) {
        // If window width is less than 600 pixels, set element with ID 'width' to 100%
        closeFeed();
    }
}
function onResize() {
    checkWidthAndSetElement();
    // Other resize-related actions if needed
}

// Attach the resize event listener
$(window).resize(function() {
    onResize();
});
